import { usePostService, type ApiResponse } from "@libs/service-providers/api-service-provider";

import { TICKETS_URL } from "./apiEndpoints";
import type { CreateTicketData } from "./types";

type CreateTicketPayload = {
  alertId: number;
};
type UsePostCreateTicketOptions = {
  onSuccess?: (response: ApiResponse<CreateTicketData>) => void;
  onError?: (error: unknown) => void;
};

export const usePostCreateTicket = (options?: UsePostCreateTicketOptions) => {
  const { onSuccess, onError, ...rest } = options ?? {};
  const mutation = usePostService<CreateTicketData, CreateTicketPayload>({
    route: TICKETS_URL,
    config: (payload) => ({
      params: { alert_id: payload.alertId },
    }),
    onSuccess,
    onError,
    ...rest,
  });

  return {
    ...mutation,
    isLoading: mutation.status === "pending",
    mutate: (payload: CreateTicketPayload) => mutation.mutate(payload),
    mutateAsync: (payload: CreateTicketPayload) => mutation.mutateAsync(payload),
  };
};
